const HisDollarSign = ({ color, sx }) => {
  const strokeColor = color ?? "#0B4EDB";
  const _sx = sx ?? {};

  return (
    <svg
      style={_sx}
      width="30"
      height="28"
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="27.551" rx="13.7755" fill="white" />
      <path
        d="M15.4497 2.53522V25.4944"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6997 5.9791H12.3247C11.1644 5.9791 10.0516 6.4024 9.23112 7.1559C8.41064 7.90939 7.94971 8.93135 7.94971 9.99695C7.94971 11.0626 8.41064 12.0845 9.23112 12.838C10.0516 13.5915 11.1644 14.0148 12.3247 14.0148H18.5747C19.735 14.0148 20.8478 14.4381 21.6683 15.1916C22.4888 15.9451 22.9497 16.9671 22.9497 18.0327C22.9497 19.0983 22.4888 20.1202 21.6683 20.8737C20.8478 21.6272 19.735 22.0505 18.5747 22.0505H7.94971"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisDollarSign;
